<template>
  <div class="main">
    <div class="six">
      <div class="position">
        <div class="pos-line">
          <div class="pos-seats">
            <div id="CO" class="seat left-top" @click="seatClick('CO')">CO</div>
            <div id="BTN" class="seat right-top" @click="seatClick('BTN')">
              BTN
              <div class="dealer">D</div>
            </div>
            <div id="SB" class="seat right" @click="seatClick('SB')">SB</div>
            <div id="BB" class="seatBB right-bottom" @click="seatClick('BB')">
              BB
            </div>
            <div id="UTG" class="seat left-bottom" @click="seatClick('UTG')">
              UTG
            </div>
            <div id="HJ" class="seat left" @click="seatClick('HJ')">HJ</div>
          </div>
        </div>
        <div class="hint">
          <div class="item">
            <div class="box" style="background-color: #f55453;"></div>
            <div class="box-text">加注</div>
          </div>
          <div class="item">
            <div class="box" style="background-color: #5ab965;"></div>
            <div class="box-text">跟注</div>
          </div>
          <div class="item">
            <div class="box" style="background-color: #3a809b;"></div>
            <div class="box-text">棄牌</div>
          </div>
        </div>
      </div>
      <div class="table">
        <img :src="imgSrc" width="100%" alt="error" />
      </div>
    </div>
  </div>
</template>

<script>
import liff from "@line/liff";
import axios from "axios";

export default {
  name: "startTable",
  components: {},
  data() {
    return {
      imgSrc: "",
    };
  },
  mounted() {
    this.liffInit();
    document.documentElement.style = "background-color: #212122";
    this.seatClick("UTG");
  },
  methods: {
    seatClick(posName) {
      this.recordEvent("liff_start_table_seats");
      if (posName === "BB") return;
      let collSeats = document.getElementsByClassName("seat");
      for (let i = 0, len = collSeats.length; i < len; i++) {
        collSeats[i].style.color = "white";
        collSeats[i].style.border = "2px solid white";
      }
      document.getElementById(posName).style.color = "#06d1ab";
      document.getElementById(posName).style.border = "3px solid #06d1ab";
      this.imgSrc = `${require("../assets/poker/" + posName + ".jpeg")}`;
    },
    liffInit() {
      liff
        .init({
          liffId: this.$route.query.id,
        })
        .then(() => {
          this.liffAccessToken = liff.getAccessToken();
          if (!this.liffAccessToken) {
            alert("accessToken error");
          } else {
            this.recordEvent("liff_start_table");
          }
        })
        .catch((error) => {
          alert(`LiffInit error: ${JSON.stringify(error)}`);
        });
    },
    recordEvent(event) {
      axios({
        method: "post",
        url: "/event_record",
        data: {
            event: event,
        },
        headers: {
          "Content-Type": "application/json",
          "Access-Token": this.liffAccessToken,
        },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hint {
  position: absolute;
  bottom: .1rem;
  right: 0;
  color: antiquewhite;
  display: flex;
}
.item {
  display: flex;
  justify-content: center;
    align-items: center;
}
.box {
  width: .8rem;
  height: .8rem;
  margin-right: .2rem;
  border-radius: 100%;
}
.box-text{
  margin-right: .6rem;
}
.position {
  position: relative;
  background-color: #212122;
  width: 100%;
  height: 15rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.pos-line {
  width: 76%;
  height: 8rem;
  border: 1px solid white;
  border-radius: 999px;
  margin-bottom: 1rem;
}
.pos-seats {
  width: 100%;
  height: 100%;
  --player-circle-size: 4em;
  position: relative;
}
.seat {
  border-radius: 50%;
  background-color: #212122;
  height: var(--player-circle-size);
  width: var(--player-circle-size);
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
  padding: 0 0.25rem;
  font-size: 0.8rem;
  color: white;
  font-weight: bold;
  line-height: 1.1;
}
.seatBB {
  border-radius: 50%;
  background-color: #212122;
  height: var(--player-circle-size);
  width: var(--player-circle-size);
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid gray;
  padding: 0 0.25rem;
  font-size: 0.8rem;
  color: gray;
  font-weight: bold;
  line-height: 1.1;
}
.dealer {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  background-color: white;
  left: -16px;
  bottom: -4px;
  border-radius: 50%;
  color: black;
  font-weight: 700;
  line-height: 1.1;
}
.left-top {
  top: calc(var(--player-circle-size) / 2 * -1);
  bottom: calc(100% - var(--player-circle-size) / 2);
  right: calc(70% - var(--player-circle-size) / 2);
}
.right-top {
  top: calc(var(--player-circle-size) / 2 * -1);
  bottom: calc(100% - var(--player-circle-size) / 2);
  right: calc(30% - var(--player-circle-size) / 2);
}
.right-bottom {
  top: calc(100% - var(--player-circle-size) / 2);
  bottom: calc(100% - var(--player-circle-size) / 2);
  right: calc(30% - var(--player-circle-size) / 2);
}
.left-bottom {
  top: calc(100% - var(--player-circle-size) / 2);
  bottom: calc(var(--player-circle-size) / 2 * -1);
  right: calc(70% - var(--player-circle-size) / 2);
}
.left {
  top: calc(50% - var(--player-circle-size) / 2);
  bottom: calc(50% - var(--player-circle-size) / 2);
  right: calc(100% - var(--player-circle-size) / 2);
  left: calc(var(--player-circle-size) / 2 * -1);
}
.right {
  top: calc(50% - var(--player-circle-size) / 2);
  bottom: calc(50% - var(--player-circle-size) / 2);
  left: calc(100% - var(--player-circle-size) / 2);
  right: calc(var(--player-circle-size) / 2 * -1);
}

h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/startTable.vue